import { Button, Group, Loader, Stack, Text } from '@mantine/core';
import { useState } from 'react';

import { TransactionType } from '@e-origin/shared';

import { NumberInput, TextInput } from '@components';
import { useEditTransactionTypeFormInitializer } from './useEditTransactionTypeFormInitializer';

interface EditTransactionTypeProps {
  transactionType?: TransactionType;
  onHide: () => void;
}

export const EditTransactionType: React.FC<EditTransactionTypeProps> = ({ transactionType, onHide }) => {
  const [formError, setFormError] = useState<string | null>(null);

  const { form, onSubmit, isSubmitting } = useEditTransactionTypeFormInitializer({
    transactionType,
  });

  const handleSubmit = async (values) => {
    setFormError(null);

    try {
      await onSubmit(values);
      onHide();
    } catch (error: any) {
      setFormError(error?.response?.data?.message || 'Failed to save transaction type');
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack gap="md" my="xl">
        <TextInput {...form.getInputProps('name')} label="Transaction type Name" placeholder="Enter transaction type name" />
        <NumberInput {...form.getInputProps('typeId')} label="Type id" placeholder="Type id" />
        <NumberInput {...form.getInputProps('maxValue')} label="Max value" placeholder="Max value" />
      </Stack>

      {formError && (
        <Text c="red" fw="bold" mt="md">
          {formError}
        </Text>
      )}

      <Group justify="center" mt="xl">
        <Button type="button" key="cancel-modal-btn" onClick={() => onHide()} disabled={isSubmitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button
          key="save-modal-btn"
          disabled={!form.isValid() || isSubmitting}
          type="submit"
          leftSection={isSubmitting && <Loader color="white" />}
          variant="filled"
          size="lg"
        >
          Save
        </Button>
      </Group>
    </form>
  );
};
